import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import appConfig, { baseUrl } from '@/config/config'
import { decryptH5Payload, encryptH5Payload } from '@/utils/h5-crypto'

const request = axios.create({
  baseURL: baseUrl,
  timeout: 15000,
})

request.interceptors.request.use(
  async config => {
    store.commit('app/addRequestNum', 1)
    const nextConfig = { ...config }
    nextConfig.headers = nextConfig.headers || {}
    const token = store.getters.token
    if (token) {
      nextConfig.headers.token = token
    }
    if (nextConfig.h5Secure && appConfig.h5SecureEnabled) {
      const rawPayload =
        nextConfig.data !== undefined
          ? nextConfig.data
          : nextConfig.params !== undefined
            ? nextConfig.params
            : {}
      const securePayload = await encryptH5Payload(rawPayload, {
        url: nextConfig.url,
        method: nextConfig.method,
      })
      nextConfig.headers['Content-Type'] = 'application/json'
      nextConfig.headers['X-H5-Encrypted'] = '1'
      nextConfig.data = securePayload.envelope
      delete nextConfig.params
      nextConfig.__h5SecureContext = securePayload.context
    }
    return nextConfig
  },
  error => {
    store.commit('app/addRequestNum', -1)
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  async response => {
    store.commit('app/addRequestNum', -1)
    let payload = response.data || {}
    if (response.config && response.config.h5Secure && appConfig.h5SecureEnabled && payload.enc === 1 && payload.data) {
      try {
        payload = {
          ...payload,
          data: await decryptH5Payload(payload.data, response.config.__h5SecureContext),
        }
      } catch (error) {
        Message.error('接口数据解密失败')
        return Promise.reject(error)
      }
    }
    if (payload.code === 200) {
      return payload.data
    }
    if (payload.msg) {
      Message.error(payload.msg)
    }
    return Promise.reject(payload)
  },
  error => {
    store.commit('app/addRequestNum', -1)
    const message =
      (error.response && error.response.data && error.response.data.msg) ||
      error.message ||
      '网络请求失败'
    Message.error(message)
    return Promise.reject(error)
  }
)

request.securePost = function securePost(url, data, config = {}) {
  const nextConfig = {
    ...config,
    h5Secure: true,
  }
  return request.post(url, data, nextConfig)
}

export default request
